import { inject, Injectable } from '@angular/core';
import {first, forkJoin, map, Observable, of, tap} from 'rxjs';
import { DashboardPersistenceService } from '../dashboard-persistence.service';
import { WidgetTableColumn } from '../../../features/widgets/models/widget-table-column';
import { Widget } from '../../../features/widgets/models/widget';
import { WidgetTable } from '../../../features/widgets/models/widget-table';
import { MockContentGeneratorService } from './mock-data/mock-content-generator.service';
import { ThemedImageKey } from '../themed-images/themed-images.model';

@Injectable({
  providedIn: 'root',
})
export class WidgetContentService {
  private readonly mockContentGenerator = inject(MockContentGeneratorService);
  private readonly dashboardPersistenceService = inject(DashboardPersistenceService);

  getContent(widget: Widget, isLiveData: boolean): Observable<Widget> {
    if (isLiveData) {
      try {
        return this.getLiveContent(widget);
      } catch {
        return of(this.mockContentGenerator.generateMockContentFor(widget));
      }
    }

    return of(this.mockContentGenerator.generateMockContentFor(widget));
  }

  private getLiveContent(widget: Widget): Observable<Widget> {
    widget.illustrationType = 'themed-image';
    widget.themedImageKey = widget.widgetName.toLowerCase().replace(/\s/g, '-') as ThemedImageKey;
    widget.showCloseButton = true;

    const datasetRetrieveCalls  = widget.tables?.map((table: WidgetTable) =>
      this.dashboardPersistenceService.getWidgetDataset('MAIN', widget.widgetKey, table.key).pipe(
        first(),
        tap((dataset: []) => {
          table.tableType = 'angular-material';
          table.headers = table.columns.map((column: WidgetTableColumn) => column.header);
          table.showHeader = true;
          table.dataset = dataset;
        })
      )
    );
    if (datasetRetrieveCalls) {
      return forkJoin(datasetRetrieveCalls).pipe(
        map(() => widget)
      );
    } else {
      return of(widget);
    }
  }
}
